import React from 'react';
import styled from 'styled-components';
import { Button } from '@trevor/ui-components';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import {
  selectFilters,
  selectIsFilterUpdated,
  selectWidgetView,
  toggleWidgetConfigurationSidebar,
} from '@/features/dashboard/dashboardSlice';
import { REMOVE_PREVIEW_WIDGET } from '@/actions/constants';
import { useUpdateDashboardFiltersMutation } from '@/features/dashboard/apiSlice';
import { useDatasourceId } from '@/hooks';
import { UUID } from '@/types';

const Container = styled.div`
  width: fit-content;
  position: absolute;
  left: 0;
  right: 0;
  bottom: -48px;
  margin: auto;
  background-color: #fff;
  border-radius: var(--radius-100);
  box-shadow: var(--elevation-soft);
`;

export type ButtonProps = {
  onClick: F0;
};

const CancelButton: React.FC<ButtonProps> = ({ onClick }) => {
  const dispatch = useAppDispatch();

  const handleClick = () => {
    dispatch(toggleWidgetConfigurationSidebar());
    dispatch({ type: REMOVE_PREVIEW_WIDGET });
    onClick();
  };

  return (
    <Button variant="secondary" onClick={handleClick}>
      Cancel
    </Button>
  );
};

const DoneButton: React.FC<ButtonProps & { dashboardId: UUID }> = ({
  onClick,
  dashboardId,
}) => {
  const dispatch = useAppDispatch();
  const isFilterUpdated = useAppSelector(selectIsFilterUpdated);
  const widgetView = useAppSelector(selectWidgetView);
  const datasourceId = useDatasourceId();
  const [updateFilters] = useUpdateDashboardFiltersMutation();
  const widgetFilters = useAppSelector(selectFilters);

  const handleClick = () => {
    dispatch(toggleWidgetConfigurationSidebar());
    if (isFilterUpdated && widgetView) {
      updateFilters({
        datasourceId,
        dashboardId,
        body: {
          ...widgetFilters,
          seriesId: widgetView._series,
        },
      });
    }
    onClick();
  };

  return (
    <Button variant="primary" onClick={handleClick}>
      Done
    </Button>
  );
};

export const WidgetBottomControls: React.FC<{
  isPreview: boolean;
  dashboardId: UUID;
}> = ({ isPreview, dashboardId }) => {
  const [hasBeenClicked, setHasBeenClicked] = React.useState(false);
  const ButtonComponent = isPreview ? CancelButton : DoneButton;

  return hasBeenClicked ? null : (
    <Container>
      <ButtonComponent
        onClick={() => setHasBeenClicked(true)}
        dashboardId={dashboardId}
      />
    </Container>
  );
};
